import { EnumBase } from 'hay-core-react';
class UsuarioGenero extends EnumBase {
    constructor() {
        super(["main.usuario.genero.masculino", "main.usuario.genero.feminino", "main.usuario.genero.indefinido"],"main.usuario.genero.indefinido" );
    }
}
const instance = new UsuarioGenero();
export default instance;